/**
 * lessonProgress.js
 * ────────────────────────────────────────────────────────────────
 * Tiny helper used by every "Restart Lesson" handler across the
 * platform (K-12, Courses, Special Edition, Living School,
 * Ordination, Name & Lineage). The InvisibleTeacher persists its
 * current section index under `it_lesson_pos:<slug>`. Bumping a
 * React key alone is not enough to "restart" — on remount the
 * teacher reads the saved index back out of localStorage and
 * resumes there. This util clears that pointer so the next mount
 * starts cleanly at section 0.
 *
 * Keep this in lock-step with InvisibleTeacher's slug logic:
 *   `lessonTitle.trim().toLowerCase().replace(/\s+/g, "_")`
 */
export function clearLessonProgress(lessonTitle) {
  try {
    const slug = (lessonTitle || "").trim().toLowerCase().replace(/\s+/g, "_");
    if (!slug) return;
    localStorage.removeItem(`it_lesson_pos:${slug}`);
    // Also reset the dashboard "pick up where you left off" pointer
    // if it currently points at this lesson — otherwise the
    // Resume card on the home dashboard would still send the
    // student back to the same saved section.
    const last = JSON.parse(localStorage.getItem("ylc_last_lesson") || "null");
    if (last && last.lessonKey === slug) {
      localStorage.setItem(
        "ylc_last_lesson",
        JSON.stringify({ ...last, sectionIndex: 0, updatedAt: Date.now() })
      );
    }
  } catch {
    /* localStorage may be unavailable in private mode — non-fatal */
  }
}
